var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp"},[_c('div',{staticClass:"loading-wrap"},[_c('div',{staticClass:"loadingid",style:(_vm.multiple),attrs:{"id":_vm.LoadingId}}),_c('span',[_vm._v("加载中...")])])])}
var staticRenderFns = []

export { render, staticRenderFns }